import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const AppointmentPickDifferentTimeSlotLoading = ({ labels  })=>/*#__PURE__*/ React.createElement("div", {
        className: "appointment-pick-different-time-slot__loading"
    }, /*#__PURE__*/ React.createElement(Loader, {
        className: "appointment-pick-different-time-slot__loader"
    }), /*#__PURE__*/ React.createElement(Text, null, labels.loading))
;
var Loading = AppointmentPickDifferentTimeSlotLoading;

export { Loading as default };
//# sourceMappingURL=AppointmentPickDifferentTimeSlotLoading.js.map
